var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("status-tag --" + _vm.tagText)},[_c('Typography',{attrs:{"as":"span","variant":"label2"}},[_vm._v("\n    "+_vm._s(_vm.textStatus)+" "+_vm._s(_vm.sufix)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }